import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axiosInstance from '../utils/axiosIntance';
import { ClipLoader } from 'react-spinners';
import ProgressBar from 'react-bootstrap/ProgressBar';
import axios from 'axios';

import { GANGSHEET_LAMBDA_URL, PREFERD_GANGSHEET_LAMBDA_URL, CREATE_IMAGES_LAMBDA_URL, PREFERD_SHEET_LAMBDA_URL, S3_BASE_URL, BATCH_SIZE, UPLOAD_CONCURRENCY } from './UploadFilesComponents/constants/constants';
import { fireLambda, mergeDuplicateSheets, sheetContentSignature } from './UploadFilesComponents/utils/utils';
import { getDpiDisplay, calculateAverageDPI, setColour, toPx, parseSizeParts, processMetadataResults } from './UploadFilesComponents/helpers/helpers';
import ImageSkeleton from './UploadFilesComponents/components/ImageSkeleton';
import CanvasRenderer from './UploadFilesComponents/components/CanvasRenderer';
import SugestedCanvasRenderer from './UploadFilesComponents/components/SugestedCanvasRenderer';
import GalleryModal from './UploadFilesComponents/components/GalleryModal';

// ─── Main Component ─────────────────────────────────────────────────────────────
const UploadFiles = () => {

  // ── State ───────────────────────────────────────────────────────────────────
  const [img, setImg] = useState([]);
  const [totalPrice, setTotalPrice] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [productTitle, setProductTitle] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [gangsheetPrice, setGangsheetPrice] = useState();
  const [preferdGangsheetPrice, setPreferdGangsheetPrice] = useState([]);
  const [imageMeasureUnit, setImageMeasureUnit] = useState(null);
  const [page, setPage] = useState(1);
  const [previewTitle, setPreviewTitle] = useState(null);
  const [marginCheck, setMarginCheck] = useState(true);
  const [loading, setLoading] = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [progressPersent, setProgressPersent] = useState(null);
  const [showGalary, setShowGalary] = useState(false);
  const [GalleryData, setGalleryData] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [store, setStore] = useState("");
  const uploadContextRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState(null);
  const [preferdData, setPreferdData] = useState([]);
  const [uploadResponse, setUploadResponse] = useState([]);
  const [preferdResponse, setPreferdResponse] = useState([]);
  const [hideGalllery, setHideGalllery] = useState(false);
  const [noPreferdSheet, setNoPreferdSheet] = useState(false);

  const [stageWidth, setStageWidth] = useState(0);
  const [stageHeight, setStageHeight] = useState(0);
  const [isSuggestion, setIsSuggestion] = useState(false);
  const [selectCategory, setSelectCategory] = useState(null);
  const [uploadingImages, setUploadingImages] = useState([]);
  const [viewMode, setViewMode] = useState('grid');
  const [isMobile, setIsMobile] = useState(false);

  // ── Mobile detection ────────────────────────────────────────────────────────
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleChange = (e) => {
      setIsMobile(e.matches);
      setViewMode(e.matches ? 'list' : 'grid');
    };
    handleChange(mediaQuery);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  // ── Initial data fetch ──────────────────────────────────────────────────────
  useEffect(() => {
    const getSettingData = async () => {
      try {
        const response = await axiosInstance.post('api/setting/getAllSettings');
        const fetchedImageMeasureUnit = response.data.data?.[0].imageMeasureUnit;
        setImageMeasureUnit(fetchedImageMeasureUnit);
        return fetchedImageMeasureUnit;
      } catch (error) {
        console.error('Error fetching setting data:', error);
        return null;
      }
    };

    const getProductMetaData = async () => {
      try {
        const response = await axiosInstance.get('api/product-variant/getProductMetaData');
        let newArr = [];
        for (let i = 0; i < response?.data?.data.length; i++) {
          const element = response?.data?.data[i];
          for (const key in element) {
            let newOptions = [];
            for (let j = 0; j < element[key].length; j++) {
              const newElement = element[key][j];
              newOptions.push({
                id: newElement.id,
                inventoryQuantity: newElement.inventoryQuantity,
                price: newElement.price,
                title: newElement.title,
              });
            }
            newArr.push({ category: key, options: newOptions });
          }
        }
        setVariantData(newArr);
        setProductTitle(newArr);
      } catch (error) {
        console.error('Error fetching product metadata:', error);
      }
    };

    const fetchData = async () => {
      const unit = await getSettingData();
      if (unit) {
        await getProductMetaData();
      }
    };

    const getGalleryData = async () => {
      try {
        const response = await axiosInstance.post('api/product-variant/getGalleryData');
        setGalleryData(response.data.data);
      } catch (error) {
        console.error('Error fetching gallery data:', error);
      }
    };

    const handleURLParams = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      // const shopId = "auto-builder.myshopify.com";
      const shopId = urlParams.get('shopId');

      if (shopId) {
        try {
          const response = await axiosInstance.post('api/setting/getAllSettings', { shopId });
          if (response?.data?.name != "Pro Subscription") {
            setHideGalllery(true);
          }
          let productId = response?.data?.data[0]?.iProductId;
          setIsSuggestion(response?.data?.data[0]?.isSuggestion);
          itemsFormik.setFieldValue('margin', response?.data?.data[0]?.defaultMargin);
          const res = await axiosInstance.post('api/auth/getAccesToken', {
            vStore: shopId,
            iProductId: productId
          });
          if (res?.data?.code === 200 && res?.data?.status === 'success') {
            localStorage.setItem('accessToken', res?.data?.AccessToken);
            localStorage.setItem('refreshToken', res?.data?.RefreshToken);
            fetchData();
            getGalleryData();
          } else {
            console.log('Error while getting access token');
          }
        } catch (error) {
          console.error('API request failed', error);
        }
      } else {
        console.log('Missing URL parameters');
      }
    };

    handleURLParams();
  }, []);

  // ── Set default selected value when product titles load ─────────────────────
  useEffect(() => {
    if (productTitle.length > 0) {
      setSelectedValue(productTitle[0].title);
      setSelectCategory(productTitle[0].category);
    }
  }, [productTitle]);

  // ── Formik setup ────────────────────────────────────────────────────────────
  const validationSchema = Yup.object({
    maging: Yup.number(),
    items: Yup.array().of(
      Yup.object().shape({
        lockAspectRatio: Yup.boolean(),
        density: Yup.number(),
        newDensity: Yup.number(),
        quantity: Yup.number(),
        aspectRatio: Yup.number(),
        width: Yup.number().required("Required"),
        height: Yup.number().required("Required"),
        originalWidth: Yup.number(),
        originalHeight: Yup.number(),
        colorResolution: Yup.string(),
        image: Yup.mixed(),
        imagePreview: Yup.string(),
      })
    ),
    gangSheet: Yup.array().of(
      Yup.object().shape({ quantity: Yup.number() })
    ),
    preferdGangSheet: Yup.array().of(
      Yup.object().shape({ quantity: Yup.number() })
    ),
    newGangSheetData: Yup.object().shape({
      preferdData: Yup.array(),
      vStore: Yup.string(),
      imageMeasureUnit: Yup.string(),
    }),
  });

  const itemsFormik = useFormik({
    initialValues: {
      margin: 0,
      items: [],
      gangSheet: [],
      preferdGangSheet: [],
      newGangSheetData: {
        preferdData: [],
        vStore: "",
        imageMeasureUnit: ""
      }
    },
    validationSchema,
    async onSubmit(values) {
      console.log('values :', values);
    },
  });

  // ── Price calculation ───────────────────────────────────────────────────────
  useEffect(() => {
    if (itemsFormik?.values?.gangSheet?.length > 0) {
      const totalQuantity = itemsFormik.values.gangSheet.reduce((sum, item) => sum + item.quantity, 0);
      const price =
        totalQuantity *
        Number(
          variantData
            .filter(group => group.category === selectCategory)
            .flatMap(g => g.options)
            .find(p => p.title === selectedValue)?.price || 0
        );
      setGangsheetPrice(Number(price.toFixed(2)));
    }

    if (itemsFormik?.values?.preferdGangSheet?.length > 0) {
      let a = [];
      for (let i = 0; i < itemsFormik.values.preferdGangSheet.length; i++) {
        const element = itemsFormik.values.preferdGangSheet[i];
        a.push({
          title: element.title,
          price: Number(
            variantData
              .filter(group => group.category === selectCategory)
              .flatMap(group => group.options)
              .find(product => product.title === element.title)?.price || 0
          ) * element.quantity,
          quantity: element.quantity
        });
      }
      setTotalPrice(a.reduce((sum, item) => sum + item.price, 0));
      setPreferdGangsheetPrice(a);
    }
  }, [itemsFormik?.values?.gangSheet, itemsFormik?.values?.preferdGangSheet]);

  // ── Helpers ─────────────────────────────────────────────────────────────────
  const calculateAspectRatio = (width, height) => width / height;

  const onImageSelect = async (e) => {
    try {
      const files = Array.from(e.target.files);
      if (files.length === 0) return;

      const pngFiles = files.filter(file => file.type === "image/png");
      if (pngFiles.length === 0) {
        alert("Please select PNG images only");
        return;
      }
      if (pngFiles.length < files.length) {
        console.warn(`Skipped ${files.length - pngFiles.length} non-PNG files`);
      }

      const skeletons = pngFiles.map((file, index) => ({
        id: Date.now() + index,
        isLoading: true,
        name: file.name
      }));
      setUploadingImages(skeletons);

      const fileInput = e.target;
      setProgressPersent(0);

      const processedItems = [];

      for (let i = 0; i < pngFiles.length; i += BATCH_SIZE) {
        const batch = pngFiles.slice(i, i + BATCH_SIZE);
        const batchNumber = Math.floor(i / BATCH_SIZE) + 1;
        console.log(`Processing batch ${batchNumber} (${batch.length} images)...`);

        const formData = new FormData();
        batch.forEach((file, index) => {
          formData.append(`images[${index}]`, file);
        });

        try {
          const uploadWeight = 0.5;
          const response = await axiosInstance.post(
            'api/product-variant/getBatchMetadata',
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' },
              timeout: 60000,
              onUploadProgress: (progressEvent) => {
                const batchUploadProgress = Math.round(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
                const batchesCompleted = i / BATCH_SIZE;
                const totalBatches = Math.ceil(pngFiles.length / BATCH_SIZE);
                const currentBatchProgress = (batchUploadProgress / 100) * uploadWeight;
                const overallProgress = Math.round(
                  ((batchesCompleted + currentBatchProgress) / totalBatches) * 100
                );
                setProgressPersent(overallProgress);
              }
            }
          );

          if (response.data.data && response.data.data.length > 0) {
            processedItems.push(...processMetadataResults(response.data.data, batch, imageMeasureUnit));
          }
          if (response.data.failed && response.data.failed.length > 0) {
            console.error('Some images failed to process:', response.data.failed);
          }
        } catch (error) {
          console.error(`Error processing batch ${batchNumber}:`, error);
          alert(`Failed to process batch ${batchNumber}. Please try again.`);
        }

        const finalProgress = Math.round(((i + batch.length) / pngFiles.length) * 100);
        setProgressPersent(finalProgress);
      }

      setTimeout(() => {
        setUploadingImages([]);
        if (processedItems.length > 0) {
          itemsFormik.setFieldValue('items', [
            ...itemsFormik.values.items,
            ...processedItems,
          ]);
          console.log(`Successfully processed ${processedItems.length} of ${pngFiles.length} images`);
        } else {
          console.error('No images were successfully processed');
          alert('Failed to process images. Please try again.');
        }
        if (fileInput) fileInput.value = '';
        setProgressPersent(null);
      }, 500);
    } catch (error) {
      console.error('Error in onImageSelect:', error);
      setUploadingImages([]);
      setProgressPersent(null);
      alert('An error occurred while uploading images. Please try again.');
    }
  };

  // ── Width/Height/Quantity handlers ──────────────────────────────────────────
  const handleWidthChange = (e, index) => {
    const newWidth = e.target.value;
    const newHeight = newWidth / itemsFormik.values.items[index]?.aspectRatio;
    const imageWidthPixels = itemsFormik.values.items[index]?.originalWidth * itemsFormik.values.items[index]?.density;
    const imageHeightPixels = itemsFormik.values.items[index]?.originalHeight * itemsFormik.values.items[index]?.density;
    const averageDPI = calculateAverageDPI(imageWidthPixels, imageHeightPixels, newWidth, newHeight.toFixed(2));
    itemsFormik.setFieldValue(`items[${index}].newDensity`, Math.round(averageDPI));
    itemsFormik.setFieldValue(`items[${index}].width`, newWidth);
    itemsFormik.setFieldValue(`items[${index}].height`, newHeight.toFixed(2));
    setColour(Math.round(averageDPI), index, itemsFormik);
  };

  const handleHeightChange = (e, index) => {
    const newHeight = e.target.value;
    const newWidth = newHeight * itemsFormik.values.items[index]?.aspectRatio;
    const imageWidthPixels = itemsFormik.values.items[index]?.originalWidth * itemsFormik.values.items[index]?.density;
    const imageHeightPixels = itemsFormik.values.items[index]?.originalHeight * itemsFormik.values.items[index]?.density;
    const averageDPI = calculateAverageDPI(imageWidthPixels, imageHeightPixels, newWidth.toFixed(2), newHeight);
    itemsFormik.setFieldValue(`items[${index}].newDensity`, Math.round(averageDPI));
    itemsFormik.setFieldValue(`items[${index}].height`, newHeight);
    itemsFormik.setFieldValue(`items[${index}].width`, newWidth.toFixed(2));
    setColour(Math.round(averageDPI), index, itemsFormik);
  };

  const handleQuantityChange = (action, index) => {
    const currentQuantity = Number(itemsFormik.values.items[index].quantity) || 1;
    if (action == "increase") {
      itemsFormik.setFieldValue(`items[${index}].quantity`, currentQuantity + 1);
    } else {
      itemsFormik.setFieldValue(`items[${index}].quantity`, Math.max(1, currentQuantity - 1));
    }
  };

  const handleDuplicate = (index) => {
    let items = [...itemsFormik.values.items];
    items.splice(index + 1, 0, itemsFormik.values.items[index]);
    itemsFormik.setFieldValue('items', items);
  };

  const handleRemove = (index) => {
    let newItems = itemsFormik.values.items.filter((_, i) => i !== index);
    itemsFormik.setFieldValue('items', newItems);
  };

  const widthChange = (e, index, lockAspect) => {
    if (!lockAspect) {
      itemsFormik.handleChange(e);
      const imageWidthPixels = itemsFormik.values.items[index]?.originalWidth * itemsFormik.values.items[index]?.density;
      const imageHeightPixels = itemsFormik.values.items[index]?.originalHeight * itemsFormik.values.items[index]?.density;
      const averageDPI = calculateAverageDPI(imageWidthPixels, imageHeightPixels, e.target.value, itemsFormik.values.items[index]?.height);
      itemsFormik.setFieldValue(`items[${index}].newDensity`, Math.round(averageDPI));
      setColour(Math.round(averageDPI), index, itemsFormik);
    } else {
      handleWidthChange(e, index);
    }
  };

  const heightChange = (e, index, lockAspect) => {
    if (!lockAspect) {
      itemsFormik.handleChange(e);
      const imageWidthPixels = itemsFormik.values.items[index]?.originalWidth * itemsFormik.values.items[index]?.density;
      const imageHeightPixels = itemsFormik.values.items[index]?.originalHeight * itemsFormik.values.items[index]?.density;
      const averageDPI = calculateAverageDPI(imageWidthPixels, imageHeightPixels, itemsFormik.values.items[index]?.width, e.target.value);
      itemsFormik.setFieldValue(`items[${index}].newDensity`, Math.round(averageDPI));
      setColour(Math.round(averageDPI), index, itemsFormik);
    } else {
      handleHeightChange(e, index);
    }
  };

  // ── Drag and Drop ───────────────────────────────────────────────────────────
  function handleDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    const uploadWrap = document.querySelector('.image-upload-wrap');
    uploadWrap.classList.add('dragging');
  }

  function handleDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    const uploadWrap = document.querySelector('.image-upload-wrap');
    uploadWrap.classList.remove('dragging');
  }

  function handleDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    const uploadWrap = document.querySelector('.image-upload-wrap');
    uploadWrap.classList.remove('dragging');
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      onImageSelect({ target: { files } });
    }
  }

  // ── Gang sheet removal ──────────────────────────────────────────────────────
  const removeGangSheet = async (image, index) => {
    try {
      setLoading2(false);
      let newItems = [...itemsFormik.values.gangSheet];
      let demo = [...uploadResponse];
      demo.splice(index, 1);
      if (!demo.length) setPage(1);
      newItems.splice(index, 1);
      if (!newItems.length) setPage(1);
      setLoading2(true);
      setUploadResponse(demo);
      itemsFormik.setFieldValue('gangSheet', newItems);
    } catch (error) {
      console.error('Error fetching metadata:', error);
    } finally {
      setLoading2(false);
    }
  };

  const removePreferdGangSheet = async (image, index) => {
    try {
      setLoading2(false);
      let newItems = [...itemsFormik.values.preferdGangSheet];
      newItems.splice(index, 1);
      if (!newItems.length) {
        setPage(1);
        setPreferdData([]);
        setNoPreferdSheet(false);
        setPreferdResponse([]);
      }
      setLoading2(true);
      itemsFormik.setFieldValue('preferdGangSheet', newItems);
      setPreferdResponse(preferdResponse.filter((_, i) => i !== index));
    } catch (error) {
      console.error('Error fetching metadata:', error);
    } finally {
      setLoading2(false);
    }
  };

  // ── Select handlers ─────────────────────────────────────────────────────────
  const handleSelectChange = (event) => {
    const [category, title] = event.target.value.split("|");
    setSelectedValue(title);
    setSelectCategory(category);
    itemsFormik.setErrors({});
  };

  const handleSelectCategoryChange = (event) => {
    setSelectCategory(event.target.value);
    itemsFormik.setErrors({});
  };

  // ── Gallery handlers ────────────────────────────────────────────────────────
  const handleCloseGalary = () => setShowGalary(false);
  const handleShowGalary = () => setShowGalary(true);

  const handleCheckboxChange = (url) => {
    setSelectedImages((prevSelected) =>
      prevSelected.includes(url)
        ? prevSelected.filter((item) => item !== url)
        : [...prevSelected, url]
    );
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleUpload = async () => {
    try {
      handleCloseGalary();
      const totalImages = selectedImages.length;
      if (totalImages === 0) {
        setProgressPersent(null);
        return;
      }

      const skeletons = selectedImages.map((_, index) => ({
        id: `gallery-${Date.now()}-${index}`,
        isLoading: true,
        name: `Gallery Image ${index + 1}`
      }));
      setUploadingImages(skeletons);
      setProgressPersent(0);

      const processedItems = [];

      for (let i = 0; i < totalImages; i += BATCH_SIZE) {
        const batchUrls = selectedImages.slice(i, i + BATCH_SIZE);
        const batchNumber = Math.floor(i / BATCH_SIZE) + 1;
        console.log(`Processing gallery batch ${batchNumber} (${batchUrls.length} images)...`);

        const fetchPromises = batchUrls.map(async (url) => {
          const imgRes = await fetch(`${process.env.REACT_APP_API_KEY}${url}`);
          const blob = await imgRes.blob();
          return new File([blob], `gallery-${Date.now()}.png`, { type: blob.type });
        });
        const batchFiles = await Promise.all(fetchPromises);

        const fetchProgress = Math.round(((i + batchUrls.length) / totalImages) * 30);
        setProgressPersent(fetchProgress);

        const formData = new FormData();
        batchFiles.forEach((file, index) => {
          formData.append(`images[${index}]`, file);
        });

        try {
          const response = await axiosInstance.post(
            'api/product-variant/getBatchMetadata',
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' },
              timeout: 60000,
              onUploadProgress: (progressEvent) => {
                const batchUploadProgress = Math.round(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
                const batchesCompleted = i / BATCH_SIZE;
                const totalBatches = Math.ceil(totalImages / BATCH_SIZE);
                const uploadPhaseProgress = 30 + Math.round(
                  ((batchesCompleted + (batchUploadProgress / 100)) / totalBatches) * 50
                );
                setProgressPersent(uploadPhaseProgress);
              }
            }
          );

          const batchesCompleted = (i + batchUrls.length) / totalImages;
          const processingProgress = 30 + Math.round(batchesCompleted * 50) + Math.round(batchesCompleted * 20);
          setProgressPersent(Math.min(processingProgress, 100));

          if (response.data.data && response.data.data.length > 0) {
            processedItems.push(...processMetadataResults(response.data.data, batchFiles, imageMeasureUnit));
          }
        } catch (error) {
          console.error(`Error processing gallery batch ${batchNumber}:`, error);
          alert(`Failed to process gallery batch ${batchNumber}. Please try again.`);
        }

        const progressPercent = Math.round(((i + batchUrls.length) / totalImages) * 100);
        setProgressPersent(progressPercent);
      }

      setTimeout(() => {
        setUploadingImages([]);
        if (processedItems.length > 0) {
          itemsFormik.setFieldValue('items', [
            ...itemsFormik.values.items,
            ...processedItems,
          ]);
          console.log(`Successfully processed ${processedItems.length} gallery images`);
        } else {
          alert('Failed to process gallery images. Please try again.');
        }
        setSelectedImages([]);
        setTimeout(() => setProgressPersent(null), 500);
      }, 500);
    } catch (error) {
      console.error('Error uploading gallery images:', error);
      setProgressPersent(null);
      setUploadingImages([]);
      alert('An error occurred while uploading gallery images. Please try again.');
    }
  };

  // ── Build Now (Page 1 → Page 2) ────────────────────────────────────────────
  const handleBuildNow = async () => {
    if (!selectCategory) {
      alert("Please Select a Size or Category");
      return;
    }
    if (!itemsFormik.values.items?.length) return;
    if (itemsFormik.errors.items) return;

    setLoading(true);
    setUploadResponse([]);
    setPreferdData([]);
    setPreferdResponse([]);

    // Determine canvas size
    let sizeString = selectedValue;
    if (!sizeString && isSuggestion && selectCategory) {
      const matchedCategory = productTitle.find((option) => option.category === selectCategory);
      sizeString = matchedCategory?.options?.[0]?.title || "";
    }

    let height, width;
    if (sizeString) {
      const parsed = parseSizeParts(sizeString, imageMeasureUnit);
      width = parsed.width;
      height = parsed.height;
    }

    // Validate items fit in canvas
    // Note: margin is the spacing between images in the packed gang sheet,
    // NOT a border around each image. For validation, we only check if the
    // image itself fits within the canvas dimensions.
    let error = false;
    const canFitInCanvas = (itemW, itemH, canvasW, canvasH) => {
      const fitsNormal = (itemW <= canvasW) && (itemH <= canvasH);
      const fitsRotated = (itemH <= canvasW) && (itemW <= canvasH);
      return fitsNormal || fitsRotated;
    };

    itemsFormik.values.items.forEach((item, index) => {
      let newWidth, newHeight;
      if (imageMeasureUnit == "in") {
        newWidth = item.width * 300;
        newHeight = item.height * 300;
      } else {
        newWidth = (item.width * 300) / 2.54;
        newHeight = (item.height * 300) / 2.54;
      }

      if (selectedValue) {
        if (!canFitInCanvas(newWidth, newHeight, width, height)) {
          itemsFormik.setFieldError(`items.${index}.width`, "Width is greater than canvas");
          itemsFormik.setFieldError(`items.${index}.height`, "Height is greater than canvas");
          error = true;
        }
      } else if (selectCategory && isSuggestion) {
        const matchedCategory = productTitle.find((option) => option.category === selectCategory);
        if (matchedCategory?.options) {
          let canFitInAnySize = false;
          for (const option of matchedCategory.options) {
            const parsed = parseSizeParts(option.title, imageMeasureUnit);
            if (canFitInCanvas(newWidth, newHeight, parsed.width, parsed.height)) {
              canFitInAnySize = true;
              break;
            }
          }
          if (!canFitInAnySize) {
            itemsFormik.setFieldError(`items.${index}.width`, "Width is greater than canvas");
            itemsFormik.setFieldError(`items.${index}.height`, "Height is greater than canvas");
            error = true;
          }
        }
      }
    });

    if (error) {
      setLoading(false);
      return;
    }

    const marginPx = marginCheck ? toPx(itemsFormik.values.margin, imageMeasureUnit) : 0;

    const getUploadKey = (item) => {
      const file = item.image;
      const fileId = file
        ? `${file.name || 'file'}|${file.size || 0}|${file.lastModified || 0}`
        : 'nofile';
      const widthPx = toPx(item.width, imageMeasureUnit);
      const heightPx = toPx(item.height, imageMeasureUnit);
      const density = item.density || 0;
      return `${fileId}|${widthPx}x${heightPx}|${density}`;
    };

    const buildVariantDataFallback = () => {
      const group = productTitle.find((option) => option.category === selectCategory);
      if (!group?.options?.length) return [];
      return group.options.map((option) => {
        const parsed = parseSizeParts(option.title, imageMeasureUnit);
        return { width: parsed.width, height: parsed.height };
      });
    };

    const items = itemsFormik.values.items;
    const cachedUploads = new Array(items.length);
    const uploadQueue = [];

    items.forEach((item, index) => {
      const uploadKey = getUploadKey(item);
      const hasCachedUpload = item.uploadKey === uploadKey && item.uploadedImage?.imgName;
      if (hasCachedUpload) {
        cachedUploads[index] = item.uploadedImage;
      } else {
        uploadQueue.push({ item, index, uploadKey });
      }
    });

    // Build FormData for a single item
    const buildFormData = (item) => {
      const widthPx = toPx(item.width, imageMeasureUnit);
      const heightPx = toPx(item.height, imageMeasureUnit);

      const fd = new FormData();
      fd.append('items', JSON.stringify([{
        width: widthPx,
        height: heightPx,
        quantity: item.quantity,
        density: item.density,
      }]));
      fd.append('image0', item.image);
      fd.append('margin', marginPx);
      fd.append('imageMeasureUnit', imageMeasureUnit);
      fd.append('category', selectCategory);
      return fd;
    };

    // Parallel uploads with concurrency limit
    const uploadWithConcurrency = async (queueItems) => {
      const results = [];
      const queue = [...queueItems];
      const worker = async () => {
        while (queue.length) {
          const { item, index, uploadKey } = queue.shift();
          const fd = buildFormData(item);
          const response = await axiosInstance.post(
            'api/product-variant/uploadImage',
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
          results.push({ index, uploadKey, data: response.data.data });
        }
      };
      await Promise.all(
        Array.from({ length: Math.min(UPLOAD_CONCURRENCY, queueItems.length) }, worker)
      );
      return results;
    };

    let uploadResults = [];
    if (uploadQueue.length) {
      try {
        uploadResults = await uploadWithConcurrency(uploadQueue);
      } catch (err) {
        console.error('Upload failed:', err);
        alert('An image failed to upload. Please try again.');
        setLoading(false);
        return;
      }
    }

    const resolvedUploads = [...cachedUploads];
    uploadResults.forEach((result) => {
      const uploadedImage = result.data?.images?.[0];
      if (uploadedImage) {
        resolvedUploads[result.index] = uploadedImage;
      }
    });

    if (resolvedUploads.some((image) => !image)) {
      alert('Some images are missing upload data. Please try again.');
      setLoading(false);
      return;
    }

    const updatedItems = items.map((item, index) => {
      const uploadKey = getUploadKey(item);
      const uploadedImage = resolvedUploads[index];
      if (!uploadedImage) return item;
      return { ...item, uploadKey, uploadedImage };
    });
    itemsFormik.setFieldValue('items', updatedItems);

    if (uploadResults.length) {
      const { vStore, variantData: uploadVariantData } = uploadResults[0].data;
      uploadContextRef.current = { vStore, variantData: uploadVariantData, category: selectCategory };
      setStore(vStore);
    }

    const uploadContext = uploadContextRef.current || {};
    const uploadResponseData = {
      images: resolvedUploads.map((image, index) => ({
        ...image,
        quantity: items[index].quantity,
      })),
      vStore: uploadContext.vStore || store,
      margin: marginPx,
      variantData: uploadContext.category === selectCategory
        ? (uploadContext.variantData || buildVariantDataFallback())
        : buildVariantDataFallback(),
    };

    if (!uploadResponseData.vStore) {
      alert('Missing store info for this build. Please try again.');
      setLoading(false);
      return;
    }

    if (!isSuggestion) {
      // Manual sheet mode
      if (selectedValue) {
        setPreviewTitle(selectedValue);
        axios.post(CREATE_IMAGES_LAMBDA_URL, {
          imagesArr: uploadResponseData.images,
          width,
          height,
          vStore: uploadResponseData.vStore,
          margin: uploadResponseData.margin,
        }).then((response) => {
          console.log('response :', response.data.data);
          // Every sheet in this batch shares the same selected size, so identical
          // sheets are distinguished purely by their packed-image content. Collapse
          // duplicates into a single card and carry the summed count as the card's
          // starting quantity instead of rendering one card per duplicate.
          const mergedSheets = mergeDuplicateSheets(
            response.data.data,
            sheet => sheetContentSignature(sheet)
          );
          setUploadResponse(mergedSheets);
          const data = mergedSheets.map(sheet => ({ quantity: sheet.quantity || 1 }));
          itemsFormik.setFieldValue('gangSheet', data);
          setLoading(false);
          setStageWidth(width);
          setStageHeight(height);
          setPage(2);
        });
      } else {
        alert('Please select a sheet size');
        setLoading(false);
      }
    } else {
      // Suggestion mode
      const reqData = {
        margin: marginCheck ? toPx(itemsFormik.values.margin, imageMeasureUnit) : 0,
        images: JSON.stringify(uploadResponseData.images),
        imageMeasureUnit,
        selectedCanvaswidth: width,
        selectedCanvasHeight: height,
        variantData: uploadResponseData?.variantData,
        vStore: uploadResponseData?.vStore,
      };

      const responseData = await axios.post(PREFERD_SHEET_LAMBDA_URL, reqData);

      const rawSheets = responseData?.data?.data || [];

      // Collapse identical suggested sheets (same size AND same packed content)
      // into one entry, summing how many times the packer produced them. This
      // merged list is the single source of truth for the cards, the per-card
      // quantity inputs, the left-hand summary and the payload sent to the sheet-
      // generation Lambda — so a duplicate becomes "x2" on one card instead of two
      // separate cards.
      const mergedSheets = mergeDuplicateSheets(
        rawSheets,
        sheet => sheetContentSignature(sheet, ['width', 'height'])
      );

      if (mergedSheets.length === 0) {
        setNoPreferdSheet(true);
      } else {
        // Left-hand summary: one row per distinct size, quantities summed across
        // all merged sheets of that size.
        const summaryBySize = mergedSheets.reduce((acc, curr) => {
          const found = acc.find(item => item.width === curr.width && item.height === curr.height);
          if (found) {
            found.quantity += curr.quantity;
          } else {
            acc.push({ ...curr });
          }
          return acc;
        }, []);
        setPreferdData(summaryBySize);
      }

      setPreferdResponse(mergedSheets);

      const newGangSheetData = {
        preferdData: mergedSheets,
        vStore: responseData.data.store,
        imageMeasureUnit,
        category: selectCategory,
      };
      itemsFormik.setFieldValue('newGangSheetData', newGangSheetData);

      const newdata = mergedSheets.map(element => ({
        quantity: element.quantity || 1,
        title: `${parseFloat(element.width).toFixed(2)} ${imageMeasureUnit} X ${parseFloat(element.height).toFixed(2)} ${imageMeasureUnit}`,
      }));
      itemsFormik.setFieldValue('preferdGangSheet', newdata);
      setLoading(false);
      setPage(2);
    }
  };

  // ── Add to Cart (Page 2) ────────────────────────────────────────────────────
  const handleAddToCart = async () => {
    let data = [];
    let newData = {};

    if (isSuggestion) {
      setCartLoading(true);

      // Generate predefined file names in advance
      const predefinedFileNames = itemsFormik.values.preferdGangSheet.map(() =>
        `${Date.now()}-${Math.random().toString(36).substring(2, 15)}.png`
      );

      itemsFormik.values.preferdGangSheet.forEach((item, index) => {
        const variantName = `${parseFloat(preferdResponse[index]?.width || 0).toFixed(2)} ${imageMeasureUnit} X ${parseFloat(preferdResponse[index]?.height || 0).toFixed(2)} ${imageMeasureUnit}`;
        const variant = productTitle
          .filter(group => group.category === selectCategory)
          .flatMap(group => group.options)
          .find(product => product.title === variantName)?.id || 0;
        let random = (Math.random() + 1).toString(36).substring(7);
        data.push({
          id: variant,
          quantity: item.quantity,
          properties: {
            sku: random,
            file: `${S3_BASE_URL}uploads/tempGangSheet/${store}/${predefinedFileNames[index]}`,
            category: selectCategory,
            predefinedFileName: predefinedFileNames[index],
            margin: marginCheck ? `${itemsFormik.values.margin}_${imageMeasureUnit}` : "0"
          }
        });
      });

      // Fire the sheet-generation Lambda and move on — it builds the sheets in the
      // background, so we don't wait for it. Not awaited = the user isn't blocked.
      const requestData = {
        ...itemsFormik.values.newGangSheetData,
        predefinedFileNames,
      };
      fireLambda(PREFERD_GANGSHEET_LAMBDA_URL, requestData);

      // Send data to parent (Shopify)
      newData.autoBuilder = data;
      setCartLoading(false);
      window.parent.postMessage(newData, "*");

    } else {
      setCartLoading(true);

      const variant = productTitle
        .filter(group => group.category === selectCategory)
        .flatMap(group => group.options)
        .find(product => product.title === selectedValue)?.id || 0;

      const { width, height } = parseSizeParts(selectedValue, imageMeasureUnit);

      // Generate predefined file names in advance
      const predefinedFileNames = itemsFormik.values.gangSheet.map(() =>
        `${Date.now()}-${Math.random().toString(36).substring(2, 15)}.png`
      );

      itemsFormik.values.gangSheet.forEach((item, index) => {
        let random = (Math.random() + 1).toString(36).substring(7);
        data.push({
          id: variant,
          quantity: item.quantity,
          properties: {
            sku: random,
            file: `${S3_BASE_URL}uploads/tempGangSheet/${store}/${predefinedFileNames[index]}`,
            category: selectCategory,
            predefinedFileName: predefinedFileNames[index],
            margin: marginCheck ? `${itemsFormik.values.margin}_${imageMeasureUnit}` : "0"
          }
        });
      });

      // Fire the sheet-generation Lambda and move on (not awaited — background job).
      const requestData = {
        imageName: uploadResponse,
        canvasWidth: width,
        canvasHeight: height,
        vStore: store,
        predefinedFileNames,
      };
      fireLambda(GANGSHEET_LAMBDA_URL, requestData);

      // Send data to parent (Shopify)
      newData.autoBuilder = data;
      setCartLoading(false);
      window.parent.postMessage(newData, "*");
    }
  };

  // ── Main submit dispatcher ──────────────────────────────────────────────────
  const handleSubmit = async () => {
    if (page === 1) {
      await handleBuildNow();
    } else if (page === 2) {
      handleAddToCart();
    }
  };

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <div>
      <div className={itemsFormik.values.items?.length ? 'mainDiv' : 'mainDiv pb-0'}>
        {/* Back button */}
        {page == 2 ?
          <div className="back-buttonDiv">
            <div className="container">
              <a href="javascript:;" className="back-button" onClick={() => {
                setPage(1);
                setPreferdData([]);
                setNoPreferdSheet(false);
                itemsFormik.setFieldValue('preferdGangSheet', []);
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width={22} height={14} viewBox="0 0 22 14" fill="none">
                  <path d="M1.37012 7.22201H20.6201M1.37012 7.22201L6.87012 12.5553M1.37012 7.22201L6.87012 1.88867" stroke="black" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Back
              </a>
            </div>
          </div>
          : null}

        {/* Page 1: Upload images */}
        {page == 1 ?
          <>
            <div className="container">
              <div className="row">
                <div className="col-lg-3">
                  <div className="uploadimageDiv">
                    <div className="file-upload">
                      <div className="image-upload-wrap" onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>
                        <h2 className="upload-title">Drag &amp; drop to Upload file<br />or</h2>
                        <div className="upload-section">
                          <label htmlFor="upload" className="uplload-fileDiv blue-button">
                            <span>Browse File</span>
                            <input type="file" id="upload" accept="image/png" onChange={onImageSelect} multiple />
                          </label>
                        </div>
                        <p className="upload-para pb-3">Supported formats: <strong>png</strong></p>
                        <div className="upload-progressDiv" style={{ display: progressPersent !== null ? 'block' : 'none' }}>
                          <ProgressBar
                            striped
                            variant="info"
                            animated
                            now={progressPersent || 0}
                            label={`${progressPersent || 0}%`}
                          />
                        </div>
                        <div className="upload-typeDiv  w-100">
                          {hideGalllery ? null :
                            <label className="upload-contentDiv" onClick={() => handleShowGalary()}>
                              <img width={25} height={25} src="assets/images/google-photos.svg" alt="Google Photos" />
                              <h3 className="upload-type-title">From Gallery</h3>
                            </label>
                          }
                          <div className="sticky-backcontiDiv">
                            {loading ? (<>
                              <ClipLoader color={"#3498db"} size={50} />
                              <p>Please wait while the sheets are generating...</p>
                            </>
                            ) : (
                              <a href="javascript:void(0)" className="continue-btn" onClick={handleSubmit}>Build Now</a>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-9">
                  <div className="multiuploaded-card position-relative">
                    <div className="custom-card">
                      {page == 1 ? <>
                        <div className="main-contentdroDiv">
                          <h4 className="card-main-title">Auto Build - Upload Multiple Images At Once</h4>

                          {!isSuggestion ? (
                            <div className="select-wrp">
                              <label>Select a Size:</label>
                              <select value={selectCategory && selectedValue ? `${selectCategory}|${selectedValue}` : ""} onChange={handleSelectChange}>
                                <option value="" disabled>Select a Size</option>
                                {productTitle.map((group, i) => (
                                  <optgroup key={i} label={group.category}>
                                    {group.options.map((option, j) => (
                                      <option key={j} value={`${group.category}|${option.title}`}>
                                        {option.title}
                                      </option>
                                    ))}
                                  </optgroup>
                                ))}
                              </select>
                            </div>
                          ) : (
                            <div className="select-wrp">
                              <label> Select Category : </label>
                              <select value={selectCategory} onChange={handleSelectCategoryChange}>
                                {selectCategory === '' && (
                                  <option value="" disabled>Select</option>
                                )}
                                {productTitle.map((option, index) => (
                                  <option key={option.category} value={option.category}>
                                    {option.category}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                          <div className="form-inputdropDiv">
                            <div className="form-check">
                              <input className="form-check-input" type="checkbox" id="flexCheckDefault" checked={marginCheck} defaultChecked={true} onChange={(e) => (setMarginCheck(e.target.checked), itemsFormik.setErrors({}))} />
                              <label className="form-check-label" htmlFor="flexCheckDefault" >
                                With Margin
                              </label>
                            </div>
                            <input
                              type="number"
                              onChange={(e) => {
                                const value = Math.max(0, e.target.value);
                                itemsFormik.setFieldValue('margin', value);
                              }}
                              onBlur={itemsFormik.handleBlur}
                              name="margin"
                              value={itemsFormik.values.margin}
                              className="form-control form-control-sm"
                              min={0}
                            />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                              {imageMeasureUnit}
                            </label>
                          </div>
                        </div>

                        <div className="row g-lg-4 g-3">
                          {/* Skeletons while uploading */}
                          {uploadingImages.length > 0 && uploadingImages.map((skeleton, index) => (
                            <ImageSkeleton key={skeleton.id || `skeleton-${index}`} />
                          ))}

                          {itemsFormik.values.items?.length ? itemsFormik.values.items?.map((data, index) => (
                            <div key={index} className="col-md-6">
                              <div className="uploaded-card">
                                <div className="upladed-imgdescription">
                                  <img className="card-uploadimages" src={data?.imagePreview} alt="Upload Image" onContextMenu={(e) => e.preventDefault()} />
                                  <div>
                                    <div className="form-inputdropDiv mb-2">
                                      <label className="form-check-label" htmlFor="flexCheckDefault">
                                        Width
                                      </label>
                                      <input
                                        type="number"
                                        onChange={(e) => widthChange(e, index, itemsFormik.values.items[index]?.lockAspectRatio)}
                                        onBlur={itemsFormik.handleBlur}
                                        name={`items[${index}].width`}
                                        value={itemsFormik.values.items[index]?.width}
                                        className="form-control form-control-sm"
                                        min="0.1"
                                      />
                                      <label className="form-check-label" htmlFor="flexCheckDefault">
                                        {imageMeasureUnit}
                                      </label>
                                    </div>
                                    {itemsFormik.errors.items?.[index]?.width && <p style={{ color: 'red' }}>{itemsFormik.errors.items?.[index]?.width}</p>}
                                    <div className="form-inputdropDiv mb-3">
                                      <label className="form-check-label" htmlFor="flexCheckDefault">
                                        Height
                                      </label>
                                      <input
                                        type="number"
                                        onChange={(e) => heightChange(e, index, itemsFormik.values.items[index]?.lockAspectRatio)}
                                        onBlur={itemsFormik.handleBlur}
                                        name={`items[${index}].height`}
                                        value={itemsFormik.values.items[index]?.height}
                                        className="form-control form-control-sm"
                                        min="0.1"
                                      />
                                      <label className="form-check-label" htmlFor="flexCheckDefault">
                                        {imageMeasureUnit}
                                      </label>
                                    </div>
                                    {itemsFormik.errors.items?.[index]?.height && <p style={{ color: 'red' }}>{itemsFormik.errors.items?.[index]?.height}</p>}
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" checked={itemsFormik.values.items[index]?.lockAspectRatio} value={itemsFormik.values.items[index]?.lockAspectRatio} id={`flexCheckDefault${index}`} defaultChecked={true} onChange={(e) => itemsFormik.setFieldValue(`items[${index}].lockAspectRatio`, e.target.checked)} />
                                      <label className="form-check-label" htmlFor={`flexCheckDefault${index}`}>
                                        Lock Aspect Ratio
                                      </label>
                                    </div>

                                    <div className="form-inputdropDiv mb-2">
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: getDpiDisplay(itemsFormik.values.items[index]?.density).svg
                                          }}
                                          style={{ width: '25px', height: '25px', display: 'inline-block' }}
                                        />
                                        <span style={{ color: getDpiDisplay(itemsFormik.values.items[index]?.density).color }}>
                                          {itemsFormik.values.items[index]?.density} DPI
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="add-removeimgDiv">
                                  <div className="incdescrse-count">
                                    <div className="minus" id="decrease" onClick={() => handleQuantityChange("decrease", index)} value="Decrease Value">-</div>
                                    <input type="number" id="number" className="input-box"
                                      onChange={itemsFormik.handleChange}
                                      onBlur={itemsFormik.handleBlur}
                                      name={`items[${index}].quantity`}
                                      value={itemsFormik.values.items[index]?.quantity}
                                    />
                                    <div className="plus" id="increase" onClick={() => handleQuantityChange("increase", index)} value="Increase Value">+</div>
                                  </div>
                                  <div className="dupli-removebtnDiv">
                                    <button className="duplicate-button" onClick={() => handleDuplicate(index)}><img width="22" height="22" src="assets/images/tabler-icon-copy.svg" alt="" /> Duplicate</button>
                                    <button className="remove-button" onClick={() => handleRemove(index)}><img width="22" height="22" src="assets/images/remove-img.svg" alt="" /> Remove</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )) : (
                            <div className="text-center">
                              <img className="img-fluid" src="assets/images/upload-img.png" alt="Uploaded Images" />
                              <p className="multiple-uploadpara">No Images uploaded, Please upload your images or select from the gallery.</p>
                            </div>
                          )}
                        </div>
                      </> : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
          : null}

        {/* Page 2: Preview & Add to Cart */}
        {page == 2 ?
          <div className="multiuploaded-card position-relative">
            <div className="container">
              <div className="row">
                <div className="col-lg-3">
                  {page == 2 ? <div className="multiuploaded-radio">
                    {!isSuggestion ?
                      <div className="w-100 p-0">
                        <input type="radio" id="radio1" value="43057015226413" name="dynamic-radio" defaultChecked />
                        <label htmlFor='radio1'>
                          <h5>Manual Sheets</h5>
                          <br />
                          <br />
                          <span>{previewTitle}</span>
                          <span className='data-qnt'>x {itemsFormik?.values?.gangSheet?.reduce((sum, item) => sum + item.quantity, 0)}</span>
                          <span className='data-qnt'><strong>${gangsheetPrice}</strong></span>
                        </label>
                      </div>
                      : null}

                    {isSuggestion ?
                      <div className="w-100 p-0">
                        <input type="radio" value="43057015226413" id="radio2" name="dynamic-radio" defaultChecked />
                        <label htmlFor="radio2">
                          <h5 style={{ fontSize: "18px" }}>Suggested Sheets</h5>
                          <br />
                          <br />
                          {preferdData.length ? preferdData.map((data, index) => (
                            <div className='radio-group' key={index}>
                              <span>{parseFloat(data.width).toFixed(2)} {imageMeasureUnit} x  {parseFloat(data.height).toFixed(2)} {imageMeasureUnit}</span>
                              {preferdGangsheetPrice?.length ? <span className='data-qnt'><strong>x{preferdGangsheetPrice.filter(sheet => sheet.title == `${parseFloat(data.width).toFixed(2)} ${imageMeasureUnit} X ${parseFloat(data.height).toFixed(2)} ${imageMeasureUnit}`).reduce((sum, item) => sum + item.quantity, 0)}</strong></span> : null}
                              {preferdGangsheetPrice?.length ? <span className='data-qnt'><strong>${preferdGangsheetPrice.filter(sheet => sheet.title == `${parseFloat(data.width).toFixed(2)} ${imageMeasureUnit} X ${parseFloat(data.height).toFixed(2)} ${imageMeasureUnit}`).reduce((sum, item) => sum + item.price, 0)}</strong></span> : null}
                            </div>
                          )) : <ClipLoader color={"#3498db"} size={20} />}
                          <div className='radio-group' style={{ borderTop: '1px solid #ddd', paddingTop: '10px', marginTop: '10px' }}>
                            <p>Total : </p>
                            <p><strong>${totalPrice}</strong></p>
                          </div>
                        </label>
                      </div>
                      : null
                    }

                    {itemsFormik.values.items?.length ?
                      <div className="sticky-backcontiDiv">
                        {page === 2 ? <a href="javascript:void(0)" className="back-adjustbtn" onClick={() => {
                          setPage(1);
                          setPreferdData([]);
                          setNoPreferdSheet(false);
                          itemsFormik.setFieldValue('preferdGangSheet', []);
                        }}>Back & Adjust</a> : null}
                        {(loading || cartLoading) ? (<>
                          <ClipLoader color={"#3498db"} size={50} />
                          <p>Please wait while sheets are added to cart...</p>
                        </>
                        ) : (
                          <a href="javascript:void(0)" className="continue-btn" onClick={handleSubmit}>Add to cart</a>
                        )}
                      </div>
                      : null}
                  </div> : null}
                </div>
                <div className="col-lg-9">
                  <div className="custom-card">
                    {page == 2 && !loading && !isSuggestion ?
                      <div className="row g-lg-4 g-2">
                        {uploadResponse?.length && uploadResponse?.map((imageGroup, index) => (
                          <div className="col-lg-6 col-xl-4" key={index}>
                            <div className="apply-card">
                              <div className="apply-titleDiv">
                                <h2 className="appy-title">Gang Sheet {index + 1}</h2>
                                <p className="location-text pt-0" style={{ display: "flex", alignItems: "center", gap: "1.5px" }}><img width="14" height="14" src="assets/images/home.svg" alt="Home" /> <span style={{ paddingTop: "3px" }}>{previewTitle}</span> </p>
                              </div>
                              <CanvasRenderer key={`canvas-${index}`} imageGroup={imageGroup} index={index} title={previewTitle} stageWidth={stageWidth} stageHeight={stageHeight} imageMeasureUnit={imageMeasureUnit} marginCheck={marginCheck} marginValue={itemsFormik.values.margin} />
                              <div className="apply-contentDiv">
                                <div className="form-inputdropDiv dropdown-quality">
                                  <label className="form-check-label" htmlFor="flexCheckDefault">
                                    Quantity
                                  </label>
                                  <input type="number" id="number" className="input-box"
                                    onChange={itemsFormik.handleChange}
                                    onBlur={itemsFormik.handleBlur}
                                    name={`gangSheet[${index}].quantity`}
                                    value={itemsFormik.values.gangSheet[index]?.quantity}
                                    min={1}
                                  />
                                </div>
                                <div className="add-removeimgDiv p-0">
                                  <button className="remove-button" onClick={() => removeGangSheet(imageGroup.imgUrl, index)}><img width="18" height="18" src="assets/images/remove-img.svg" alt="" />Remove</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div> : (
                        page == 2 && loading ? <div className='loader'><ClipLoader color={"#3498db"} size={100} /></div> : null
                      )}

                    {page == 2 && !loading2 && isSuggestion ?
                      <div className="row g-lg-4 g-2">
                        {preferdResponse?.length && preferdResponse?.map((data, index) => (
                          <div className="col-lg-6 col-xl-4" key={index}>
                            <div className="apply-card">
                              <div className="apply-titleDiv">
                                <h2 className="appy-title">Gang Sheet {index + 1}</h2>
                                <p className="location-text pt-0" style={{ display: "flex", alignItems: "center", gap: "1.5px" }}><img width="14" height="14"
                                  src="assets/images/home.svg" alt="Home" /> <span style={{ paddingTop: "3px" }}>{parseFloat(data.width).toFixed(2)} {imageMeasureUnit} x {parseFloat(data.height).toFixed(2)} {imageMeasureUnit}</span>  </p>
                              </div>
                              <SugestedCanvasRenderer key={`canvas-${index}`} imageGroup={data?.packedImages} index={index} title={previewTitle} width={data.pxWidth} height={data.pxHeight} originalHeight={data.height} originalWidth={data.width} imageMeasureUnit={imageMeasureUnit} marginCheck={marginCheck} marginValue={itemsFormik.values.margin} />
                              <div className="apply-contentDiv">
                                <div className="form-inputdropDiv dropdown-quality">
                                  <label className="form-check-label" htmlFor="flexCheckDefault">
                                    Quantity
                                  </label>
                                  <input type="number" id="number" className="input-box"
                                    onChange={itemsFormik.handleChange}
                                    onBlur={itemsFormik.handleBlur}
                                    name={`preferdGangSheet[${index}].quantity`}
                                    value={itemsFormik.values.preferdGangSheet[index]?.quantity}
                                    min={1}
                                  />
                                </div>
                                <div className="add-removeimgDiv p-0">
                                  <button className="remove-button" onClick={() => removePreferdGangSheet(data.imgUrl, index)}><img width="18" height="18" src="assets/images/remove-img.svg" alt="" />Remove</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div> : (
                        page == 2 && loading2 ? <div className='loader'><ClipLoader color={"#3498db"} size={100} /></div> : null
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          : null}
      </div>

      {/* Gallery Modal */}
      <GalleryModal
        showGalary={showGalary}
        handleCloseGalary={handleCloseGalary}
        isMobile={isMobile}
        selectedImages={selectedImages}
        handleCheckboxChange={handleCheckboxChange}
        GalleryData={GalleryData}
        searchQuery={searchQuery}
        handleSearchChange={handleSearchChange}
        selectedCategory={selectedCategory}
        handleCategoryChange={handleCategoryChange}
        viewMode={viewMode}
        setViewMode={setViewMode}
        handleUpload={handleUpload}
      />
    </div>
  );
}

export default UploadFiles